<form [formGroup]="form" class="row">
	<mat-form-field class="col">
		<mat-label>{{ matLabel }}</mat-label>
		<input matInput aria-label="Username" type="text" [placeholder]="placeholder" [name]="controlName"
			[formControlName]="controlName" [matAutocomplete]="auto" />
		<button type="button" mat-icon-button matSuffix [attr.aria-label]="'Username Valid'"
			[color]="msg && msg.SUCCESS ? 'primary' : 'warn'" tabindex="-1">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && msg">
				{{ msg.SUCCESS ? "done" : "close" }}
			</mat-icon>
		</button>
	</mat-form-field>
	<app-msg class="msg-up-closer" *ngIf="!isLoading && (msg && !msg.SUCCESS)" [msg]="msg"></app-msg>

	<mat-autocomplete #auto="matAutocomplete">
		<mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"></mat-option>
	</mat-autocomplete>
</form>